<template>
  <MaterialCard
    v-if="sensor != null"
    color="green"
    :style="`position: sticky; top: ${offsetTop}px; z-index: 10;`"
    full-width
  >
    <v-tabs v-model="active">
      <v-tab ripple>
        詳細
      </v-tab>
      <v-tab
        ripple
        :disabled="customer == null"
      >
        タンク
        <v-icon v-if="customer == null">
          mdi mdi-window-close
        </v-icon>
      </v-tab>
      <v-tab-item>
        <v-card flat>
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    class="purple-input"
                    label="シリアルNo"
                    readonly
                    :value="sensor.serialNo"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    class="purple-input"
                    label="通信ID"
                    readonly
                    :value="sensor.sensorId"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    class="purple-input"
                    label="センサータイプ"
                    readonly
                    value="C01"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    class="purple-input"
                    label="備考"
                    :value="sensor.remarks"
                    readonly
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-tab-item>
      <v-tab-item v-if="customer != null">
        <v-card flat>
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    label="顧客No"
                    class="purple-input"
                    readonly
                    :value="customer.code"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    label="タンクNo"
                    class="purple-input"
                    readonly
                    :value="tank.id"
                  />
                </v-flex>
                <v-flex
                  xs12
                >
                  <v-text-field
                    class="purple-input"
                    label="所有者"
                    readonly
                    :value="customer.name"
                  />
                </v-flex>
                <v-flex
                  xs12
                >
                  <v-text-field
                    class="purple-input"
                    label="住所"
                    readonly
                    :value="customer.address"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    label="タンク容量"
                    class="purple-input"
                    readonly
                    :value="tank.tankMaxVolume"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    label="しきい値"
                    class="purple-input"
                    readonly
                    :value="tank.volumeThreshold"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </MaterialCard>
</template>

<script>
import { mapState } from 'vuex'
import { api } from '@/api'

export default {
  props: {
    sensor: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      customer: null,
      tank: null,
      active: null
    }
  },
  computed: {
    ...mapState('display', ['offsetTop'])
  },
  watch: {
    async sensor (value) {
      this.active = 0
      if (value == null || value.installStatus === 0) {
        this.customer = null
        this.tank = null
        return
      }

      const response = await api.getCustomerTank(value.tankOwnerId, value.tankId)
      this.customer = response.customer
      this.tank = response.tank
    }
  }
}
</script>
